export const PROCESS_MANAGEMENT_EVENT_PAYLOADS = {
  PROCESS_MANAGEMENT_ITEMS_UPDATED: {} as {
    itemIds: Array<string>;
  },
} as const;

export type ProcessManagementEventPayload = typeof PROCESS_MANAGEMENT_EVENT_PAYLOADS;
